export class LabSampleType {
    labSampleTypeId: number;
    typeName: string;
}

export class LabMainDetail {
    labMainDetailId: number;
    labDepartmentId: number;
    labSampleTypeId: number;
    createdBy: number;
    modifiedBy?: number;
    totalItems: number;

    testName: string;
    testCode: string;
    typeName: string;
    departmentName: string;
    createdByName: string;
    modifiedByName: string;
    joined: string;

    active: boolean;
    isInternalLab: boolean;
    isExternalLab: boolean;
    sampleUsage: string;
    createdDate: Date;
    modifiedDate?: Date;

    charges: Array<LabMainDetailCharge>;
    templates: Array<LabMainDetailTemplate>;
    isLoading: boolean;
    patientLabDetailId?: number;
    chargeExistForCurrentLocation?: number;
    chargesSet?: boolean;
    selected: boolean;
    nablRequired: boolean;
    consentFormRequired: boolean;
    assignDoctorRequired: boolean;
    labVacutainerId: number;
    labVacutainerName: string;
    noOfSamplesCollect: number;
    noOfSamplesCollectText: string;
    testPrecaution: string;
    trim: any;
    constructor() {
        this.charges = new Array<LabMainDetailCharge>();
        this.templates = new Array<LabMainDetailTemplate>();
    }
}

export class LabMainDetailCharge {
    labMainDetailChargeId: number;
    labMainDetailId: number;
    chargeCategoryId: number;
    rate?: number;
    locationId: number;
    locationName: string;
    chargeCategoryName: string;
    default: boolean;
}

export class LabMainDetailTemplate {
    labMainDetailTemplateId: number;
    labMainDetailId: number;
    labTemplateHeaderId: number;
    priority: number;
    templateName: string;
    templateId: string;
}